import { useTranslation } from 'react-i18next';
import { FormAction } from '@anytag/shared-types';
import { BaseModal, Form, ModalBody, ModalFooter, ModalProps } from '@anytag/shared-atoms';
import { PasswordField } from '../../rhf-fields';
import { ChangePasswordSchema } from './schema';
import { ChangePasswordFormKeys, ChangePasswordFormValues } from './types';

export interface ChangePasswordFormModalProps
  extends FormAction<ChangePasswordFormValues>,
    Pick<ModalProps, 'open' | 'onClose'> {
  loading?: boolean;
}

export const ChangePasswordFormModal = ({
  open,
  onClose,
  loading,
  onSubmit,
  defaultValues
}: ChangePasswordFormModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal open={open} onClose={onClose} title={t('Dialog.Change Password')} asChild>
      <Form.Provider<ChangePasswordFormValues>
        onSubmit={onSubmit}
        zodSchema={ChangePasswordSchema}
        defaultValues={{
          password: defaultValues?.password || '',
          currentPassword: defaultValues?.currentPassword || '',
          passwordConfirm: defaultValues?.passwordConfirm || ''
        }}
      >
        {({ reset }) => (
          <>
            <ModalBody>
              <PasswordField<ChangePasswordFormKeys>
                name="currentPassword"
                title={t('Password.Current Password')}
                placeholder={t<string>('Password.Current Password')}
                required
              />

              <PasswordField<ChangePasswordFormKeys>
                name="password"
                title={t('Password.New Password')}
                placeholder={t<string>('Password.Fill New Password')}
                dynamicError
                required
              />

              <PasswordField<ChangePasswordFormKeys>
                name="passwordConfirm"
                title={t('Password.Confirm Password')}
                placeholder={t<string>('Password.Confirm new password')}
                dynamicError
                required
              />
            </ModalBody>

            <ModalFooter
              cancelButton={{
                onClick: () => {
                  onClose?.();
                  reset();
                }
              }}
              submitButton={{ type: 'submit', loading, title: t('Button.Change') }}
            />
          </>
        )}
      </Form.Provider>
    </BaseModal>
  );
};

export * from './types';
